<template>
  <section>

    <ViewLoader v-if="loading"/>
    <div class="container intro-section center-page-content" v-else>

      <div class="row">
        <div class="col text-center">
          <!-- FOR DEBUG -->
          <!--
          <h3>STATUS: {{ status }}</h3>
          <ul>
            <li v-for="(value, key, i) in $route.query" :key="i" class="mb-2">
              {{ key }}: <b>{{ value }}</b>
            </li>
          </ul>
          <hr>-->

          <div v-if="isSuccess">
             <Icon name="grCheckCircleBroken" width="36" class="mb-3"/>
            <h2 class="title">
              {{ $t('pages.checkout_success.title') }}
            </h2>
          </div>
          <div v-else-if="isFailure">
             <Icon name="grAlertTriangle" width="36" class="mb-3"/>
            <h2 class="title">
              {{ $t('pages.checkout_error.title') }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>

import ViewLoader from "@/components/ViewLoader";
import {PAYMENT_FAILURE, PAYMENT_PENDING, PAYMENT_SUCCESS, PAYMENT_METHOD_MERCADO_PAGO} from "@/consts";


export default {
  data() {
    return {
      loading: true
    }
  },
  components: {
    ViewLoader
  },

  props: {
    status: {
      type: String,
    },
  },
  computed: {
    isSuccess() {
      return this.status === PAYMENT_SUCCESS
    },
    isFailure() {
      return this.status === PAYMENT_FAILURE || this.status === PAYMENT_PENDING
    },
    paymentId() {
      return this.$route.query.payment_id
    },
    preferenceId() {
      return this.$route.query.preference_id
    }
  },

  beforeMount() {
    window.scrollTo(0, 0);
  },

  mounted() {
    if (this.isSuccess) {
      this.confirmPayment()
    } else {
      this.loading = false
    }
  },
  methods: {
    confirmPayment() {
      this.loading = false

     /* CartService.confirmPayment(this.preferenceId, PAYMENT_METHOD_MERCADO_PAGO, {"payment_id": this.paymentId}).then(response => {
        console.log(response)
      }).catch(error => {

      }).finally(() =>{
        this.loading = false
      })*/
    },
  }
}
</script>
